import React from 'react';
import styles from './LiveStatusBanner.module.css';

export const LiveStatusBanner: React.FC = () => (
  <div className={styles.banner}>
    <div className={styles.left}>
      <div className={styles.iconWrapper}>
        <svg viewBox="0 0 24 24" fill="currentColor" width="22" height="22">
          <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 14H9V8h2v8zm4 0h-2V8h2v8z"/>
        </svg>
      </div>
      <div>
        <div className={styles.titleRow}>
          <span className={styles.title}>Live Location Tracking Active</span>
          <span className={styles.alwaysOnBadge}>Always On</span>
        </div>
        <p className={styles.subtitle}>You can track their location and route progress in real-time</p>
      </div>
    </div>
    <div className={styles.broadcasting}>
      <span className={styles.broadcastDot} />
      Broadcasting
    </div>
  </div>
);
